// extracted by mini-css-extract-plugin
module.exports = {"body":"_1a0koo_86ptsSmsM3CBJPa","loader":"_2nMVzue5tMHkp5LBD7rOJn","face":"LyqP9qB0cL5weguVm6zo6","animate":"CgMxTCKt12gB8VZORO6MP","circle":"_2FXghkzMgn2_Cm1Zo-KZI6"};